<script>
import Popin from "@/containers/popin-adaptive";
import PaymentCardList from "@/components/organisms/payment-card-list";
import Titre from "@/components/atoms/titre";
import RenameCardForm from "@/containers/payment-card-list/rename-card-form";
import DeleteCardForm from "@/containers/payment-card-list/delete-card-form";

export default {
  name: "MesCartesBancaires",
  components: {
    Popin,
    PaymentCardList,
    Titre,
    RenameCardForm,
    DeleteCardForm
  },
  props: {
    cartesBancaires: {
      type: Array,
      required: false,
      default: () => []
    },
    aliasMaxParMagasin: {
      type: Number,
      required: false,
      default: 0
    }
  },
  emits: ["refreshCards"],
  data() {
    return {
      selectedCarte: {}
    };
  },
  methods: {
    renameCard(carte) {
      this.selectedCarte = carte;
      this.$refs.renommerCarte.show();
    },
    deleteCard(carte) {
      this.selectedCarte = carte;
      this.$refs.supprimerCarte.show();
    },
    renameValid() {
      this.$refs.renommerCarte.hide();
      this.$emit("refreshCards");
    },
    deleteValid() {
      this.$refs.supprimerCarte.hide();
      this.$emit("refreshCards");
    }
  }
};
</script>

<template>
  <div class="c-mes-cartes-bancaires">
    <Titre
      tag="h1"
      variant="primary"
      class="u-mb-md u-text-center@md u-m-sm@md u-mb-md@md"
    >
      Mes cartes bancaires enregistrées
    </Titre>
    <PaymentCardList
      :cartes-bancaires="cartesBancaires"
      :alias-max-par-magasin="aliasMaxParMagasin"
      @renameCard="renameCard"
      @deleteCard="deleteCard"
    />
    <Popin ref="renommerCarte">
      <RenameCardForm
        :carte="selectedCarte"
        @renameValid="renameValid()"
      />
    </Popin>
    <Popin ref="supprimerCarte">
      <DeleteCardForm
        :carte="selectedCarte"
        @deleteValid="deleteValid()"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/mes-cartes-bancaires.scss";
</style>
